//资政证书
import AllImage1 from '../image/Qualifications/1.jpg';
import AllImage2 from '../image/Qualifications/2.jpg';
import AllImage3 from '../image/Qualifications/3.jpg';
import AllImage4 from '../image/Qualifications/4.png';
import AllImage5 from '../image/Qualifications/5.jpg';
import AllImage6 from '../image/Qualifications/6.jpg';
import AllImage7 from '../image/Qualifications/7.jpg';
import AllImage8 from '../image/Qualifications/8.jpg';
import AllImage9 from '../image/Qualifications/9.jpg';
//石材
import StoneAll1 from '../image/Stone/huanghou.jpg';
import StoneAll2 from '../image/Stone/test.jpg';
import StoneAll3 from '../image/Stone/263.jpg';
import StoneAll4 from '../image/Stone/66500budui.jpg';
import StoneAll5 from '../image/Stone/66500budui1.jpg';
import StoneAll6 from '../image/Stone/dongfang.jpg';
import StoneAll7 from '../image/Stone/dongfanyuanlib.jpg';
// 保洁
import CleaningAll1 from '../image/Cleaning/xinke.jpg';
import CleaningAll2 from '../image/Cleaning/renshou.jpg';
import CleaningAll3 from '../image/Cleaning/1.jpg';
import CleaningAll4 from '../image/Cleaning/2.jpg';
import CleaningAll5 from '../image/Cleaning/3.jpg';

// 外墙清洗
import ExternalAll1 from '../image/External/renshou.jpg';
import ExternalAll2 from '../image/External/lijing.jpg';
import ExternalAll3 from '../image/External/jianwai.jpg';
import ExternalAll4 from '../image/External/3.jpg';
var  mack={
    imageAll:[
      {
        image:AllImage1,
        text:'北京清洁协会会员单位'
      },{
        image:AllImage2,
        text:'资质证书'
      },{
        image:AllImage3,
        text:'营业执照'
      },{
        image:AllImage4,
        text:'中国石材协会会员证书'
      },{
        image:AllImage5,
        text:'诚信企业家荣誉证书'
      },{
        image:AllImage6,
        text:'诚信经纪人荣誉证书'
      },{
        image:AllImage7,
        text:'诚信服务信誉证书'
      },{
        image:AllImage8,
        text:'重合同守信证书'
      }],
    imageAll2:[
        {
            image:AllImage9,
            text:'诚信经营示范单位证书'
        }
    ],
    StoneAll:[
      {
        'image':StoneAll1,
        'text': "黄石国际"
      },
      {
        'image':StoneAll2,
        'text': "xxxx"
      },
      {
        'image':StoneAll3,
        'text': "二六三"
      },
      {
        'image':StoneAll4,
        'text': "66500部队"
      },
      {
        'image':StoneAll5,
        'text': "66500部队"
      },
      {
        'image':StoneAll6,
        'text': "东方园林"
      },
      {
        'image':StoneAll7,
        'text': "东方园林总部"
      },
    ],
    CleaningAll:[
      {
        'image':CleaningAll1,
        'text': "辛克"
      },{
        'image':CleaningAll2,
        'text': "人寿中心"
      },{
        'image':CleaningAll3,
        'text': "1"
      },{
        'image':CleaningAll4,
        'text': "2"
      },
    ],
    ExternalAll:[
      {
        'image':ExternalAll1,
        'text': "人寿中心"
      },{
        'image':ExternalAll2,
        'text': "丽都酒店"
      },{
        'image':ExternalAll3,
        'text': "建外SOLO"
      },{
        'image':ExternalAll4,
        'text': "北京金融界交易所"
      },
    ],
    indexCase:[
      {
        'image':StoneAll1,
        'text': "黄石国际"
      },
      {
        'image':ExternalAll1,
        'text': "人寿中心"
      },
      {
        'image':StoneAll3,
        'text': "二六三"
      },
      {
        'image':StoneAll5,
        'text': "66500部队"
      },{
        'image':ExternalAll3,
        'text': "建外SOLO"
      },{
        'image':ExternalAll4,
        'text': "北京金融界交易所"
      }
    ]
}
export default mack;
